import {Howl, Howler} from 'howler';
import {reject} from "../../libs/nunjucks";

// AudioPlayer handling class
export class AudioPlayer {

  constructor() {
    this.audios = [];
  }

  play(filename, volume, forcePlay, callback, triggerLastClickUpdate) {
    volume = typeof volume !== "undefined" ? volume : 1.0;
    forcePlay = typeof forcePlay !== "undefined" ? forcePlay : false;
    callback = typeof callback !== "undefined" ? callback : false;
    triggerLastClickUpdate = typeof triggerLastClickUpdate !== "undefined" ? triggerLastClickUpdate : false;


    // First check if the sound is already playing so we do not start it again
    var isPlaying = this.isPlaying(filename);

    if (isPlaying && !forcePlay) {
      console.log("Track already playing and no force play defined", filename, this.audios);
      return;
    }


    var randID = window.guid();

    // var audio = document.createElement('audio');
    // $(audio).attr("id", randID);
    // $(audio).attr("preload", "none");

    // add the audio to the body so we can safely delete it later on
    // $("body").append(audio);
    //
    // audio.src = filename;
    //
    // $(audio).one("ended", $.proxy(function () {
    // 	if (typeof this.audios[0].callback == "function") {
    // 		this.audios[0].callback();
    // 	}
    // 	this.clearTrack(randID);
    // }, this));
    //
    // $(audio).off("timeupdate").on("timeupdate", $.proxy(function () {
    // 	if (this.audios[0].triggerLastClickUpdate == true) {
    // 		app.resetTimer();
    // 	}
    // }, this));
    //
    // audio.play();
    //
    //
    // this.audios.push({
    // 	el: audio,
    // 	id: randID,
    // 	filename: filename,
    // 	callback: callback,
    // 	triggerLastClickUpdate: triggerLastClickUpdate,
    // });


    var sound = new Howl({
      src: [filename],
      volume: volume,
      // html5: true
    });

    sound.once("end", () => {
      if (typeof this.audios[0].callback == "function") {
        this.audios[0].callback();
      }
      this.clearTrack(randID);
    });

    const interval = setInterval(() => {
      if (triggerLastClickUpdate) {
        if (sound.playing()) {
          app.resetTimer();
        }
      }
    }, 1000)

    sound.play();

    this.audios.push({
      el: sound,
      id: randID,
      filename: filename,
      callback: callback,
      interval: interval,
      triggerLastClickUpdate: triggerLastClickUpdate,
    });

    return this.audios[this.audios.length - 1];
  }

  clearTrack(id) {
    for (var i = 0; i < this.audios.length; i++) {

      if (this.audios[i].id == id) {

        // var $el = $("#" + id);
        // $el.attr("src", "");
        // $el.get(0).load();
        // $el.off().remove();

        clearInterval(this.audios[i].interval);
        this.audios[i].el.unload();

        // console.log("Track cleared", id, this.audios[i].filename);
        this.audios[i].id = false;
        this.audios[i].el = false;
        this.audios[i].filename = false;
        this.audios[i].callback = false;
        this.audios.splice(i, 1);
        break;
      }
    }
  }

  clearAll(id) {
    for (var i = 0; i < this.audios.length; i++) {
      this.clearTrack(this.audios[i].id)
    }
  }

  isPlaying(filename) {
    var playing = false;

    for (var i = 0; i < this.audios.length; i++) {
      if (this.audios[i].filename == filename) {
        playing = true;
        break;
      }
    }

    return playing;
  };

  preload(audioFiles, callback) {
    return new Promise((resolve, reject) => {
      let loaded = 0;

      if (audioFiles.length === 0) {
        // No files to load
        console.log("no files given");
        resolve();

      } else {
        for (let i in audioFiles) {
          const audio = new Audio();
          audio.preload = "auto";
          audio.muted = "muted";
          // audio.autobuffer = "auto";

          // once this file loads,
          // the file will be kept by the browser as cache
          audio.addEventListener('canplaythrough', function () {
            // this will be called every time an audio file is loaded
            // we keep track of the loaded files vs the requested files
            loaded++;
            // console.log("playthrough", loaded, audioFiles.length)
            if (loaded === audioFiles.length) {
              // all have loaded
              resolve();
            }
          }, false);

          audio.addEventListener('error', function (e) {
            reject(new Error(`Could not load ${audioFiles[i]}`));
          });

          audio.src = audioFiles[i];
          audio.load();
        }
      }
    })
  }
}
